import React, {useState, useEffect} from "react";

import {Table} from "../../../common/table/Table";
import {retrieveAllFacilities} from "../../../../services/FacilityService";

export const FacilityTable = ({context, setContext, navigateTo, setSpinnerText, showToaster}) => {

    const [facilities, setFacilities] = useState([]);

    useEffect(() => {
        setSpinnerText("Retrieving Locations")
        const fetchData = async () => {
            const [data, error] = await retrieveAllFacilities(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    setFacilities(data.foundLocationVOs);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);


    const handleRowClick = (facility) => {
        const facilityToBeEdited = {
            externalReference: facility.externalReference,
            country: {value: facility.country, label: facility.country},
            province: {value: facility.province, label: facility.province},
            district:facility.district,
            subDistrict:facility.subDistrict,
            facility: facility.facility,
            active: facility.active,
        };
        setContext((prevState) => ({
            ...prevState,
            selectedFacility: facilityToBeEdited,
        }));
        navigateTo("facilityCapture");
    }

    const handleAddButtonClick = () => {
        setContext((prevState) => ({
            ...prevState,
            selectedFacility: null,
        }));
        navigateTo("facilityCapture");
    }

    return (
        <div className="admin-table-container">
            <Table tableData={facilities} searchEnabled={true} buttonText="Add Location"
                   onButtonClick={handleAddButtonClick} onRowClick={handleRowClick}
                   hiddenColumns={["externalReference", "isDeleted", "created", "lastModified"]}/>
        </div>
    );
}
